import React from 'react'
import { Tabs, Tab, Button, Badge } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import Headroom from 'react-headroom'
import { INavTabProps } from '../../interface'
import { TabsBox } from '../../styles'
import { FormattedMessage } from 'react-intl'

interface INavBarSecondary {
  navBarSecondaryTab?: any
  indicatorColor?: string
  storeURL?: string
}

export default function NavBarSecondary(props: INavBarSecondary) {
  const location = useLocation()
  const [value, setValue] = React.useState(false)
  const product = props.storeURL?.includes('matrixgold') ? 'Matrixgold' : 'Countersketch'
  const pageSource = location.pathname.includes('user-area')
    ? 'User Area'
    : location.pathname.includes('legal')
      ? 'Legal'
      : product

  React.useEffect(() => {
    const val = props.navBarSecondaryTab.findLastIndex((item: INavTabProps) =>
      window.location.pathname.startsWith(item.url)
    )
    setValue(val > -1 ? val : false)
  }, [location, props.navBarSecondaryTab])

  return (
    <Headroom style={{ top: 'auto', zIndex: 99, height: 72 }}>
      <TabsBox
        data-gtm-click-section='Secondary Nav'
        data-gtm-click-subsection1={`${pageSource} Menu`}
        sx={{ alignItems: 'center', height: '100%' }}
      >
        <Tabs
          value={value}
          TabIndicatorProps={{
            style: {
              backgroundColor: props.indicatorColor
            }
          }}
        >
          {props.navBarSecondaryTab.map((navTab: INavTabProps) => (
            <Tab
              data-gtm-click-subsection2={
                navTab.url === '/matrixgold' || navTab.url === '/countersketch' ? 'Icon' : undefined
              }
              sx={{ height: '100%', minHeight: 72 }}
              disableRipple={true}
              component={Link}
              label={
                navTab.new ? (
                  <Badge
                    badgeContent={<FormattedMessage id='common.new' />}
                    color='primary'
                    overlap='rectangular'
                    sx={{
                      '& .MuiBadge-badge': {
                        fontSize: 10,
                        bgcolor: 'transparent',
                        color: 'primary.light',
                        transform: 'none',
                        top: 14,
                        left: '50%',
                        translate: '-50% 0'
                      }
                    }}
                  >
                    {navTab.label}
                  </Badge>
                ) : (
                  navTab.label
                )
              }
              to={navTab.url}
              key={navTab.url}
              data-cy={navTab.dataCy}
            />
          ))}
        </Tabs>
        {props.storeURL && (
          <Button
            size='small'
            variant='contained'
            color='secondary'
            sx={{ fontSize: '.75rem', fontWeight: 700, mx: 2 }}
            component={Link}
            to={props.storeURL}
          >
            <FormattedMessage id='common.buyNow' />
          </Button>
        )}
      </TabsBox>
    </Headroom>
  )
}
